import { IIconBase } from '..'

const trashTableIcon = ({
  color = '#333752',
  height = 14,
  width = 14,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.25 3.48832C10.3075 3.29582 8.35333 3.19666 6.405 3.19666C5.25 3.19666 4.095 3.25499 2.94 3.37166L1.75 3.48832'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.95898 2.89919L5.08732 2.13502C5.18065 1.58085 5.25065 1.16669 6.23648 1.16669H7.76482C8.75065 1.16669 8.82648 1.60419 8.91398 2.14085L9.04232 2.89919'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.9956 5.33167L10.6164 11.2058C10.5522 12.1217 10.4997 12.8333 8.87224 12.8333H5.12724C3.49974 12.8333 3.44724 12.1217 3.38307 11.2058L3.00391 5.33167'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.02539 9.625H7.96789'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.54102 7.29169H8.45768'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default trashTableIcon
